"use strict";
"use strict";
var firstPromise = new Promise(function(resolve, reject) {
    var handleLeftClick = function() {
        clearTimeout(timeoutId);
        document.removeEventListener("click", handleLeftClick);
        resolve("First promise was resolved");
    };
    document.addEventListener("click", handleLeftClick);
    var timeoutId = setTimeout(function() {
        document.removeEventListener("click", handleLeftClick);
        reject(new Error("First promise was rejected"));
    }, 3000);
});
var secondPromise = new Promise(function(resolve) {
    var cleanUpListeners = function() {
        document.removeEventListener("click", handleLeftClick);
        document.removeEventListener("contextmenu", handleRightClick);
    };
    var handleLeftClick = function() {
        cleanUpListeners();
        resolve("Second promise was resolved");
    };
    var handleRightClick = function(e) {
        e.preventDefault();
        cleanUpListeners();
        resolve("Second promise was resolved");
    };
    document.addEventListener("click", handleLeftClick);
    document.addEventListener("contextmenu", handleRightClick);
});
var thirdPromise = new Promise(function(resolve) {
    var hasLeftClicked = false;
    var hasRightClicked = false;
    var checkBothClicks = function() {
        if (hasLeftClicked && hasRightClicked) {
            document.removeEventListener("click", handleLeftClick);
            document.removeEventListener("contextmenu", handleRightClick);
            resolve("Third promise was resolved");
        }
    };
    var handleLeftClick = function() {
        hasLeftClicked = true;
        checkBothClicks();
    };
    var handleRightClick = function(e) {
        e.preventDefault();
        hasRightClicked = true;
        checkBothClicks();
    };
    document.addEventListener("click", handleLeftClick);
    document.addEventListener("contextmenu", handleRightClick);
});
var successHandler = function(message) {
    var div = document.createElement("div");
    div.dataset.qa = "notification";
    div.classList.add("success");
    div.textContent = message;
    document.body.appendChild(div);
};
var errorHandler = function(error) {
    var div = document.createElement("div");
    div.dataset.qa = "notification";
    div.classList.add("error");
    div.textContent = error.message || error;
    document.body.appendChild(div);
};
firstPromise.then(successHandler).catch(errorHandler);
secondPromise.then(successHandler);
thirdPromise.then(successHandler);

//# sourceMappingURL=index.f9740484.js.map
